import React, { useState } from 'react';
import axios from 'axios';
// const [imgurl, setImgurl] = useState()
export const FileUpload = (props) => {
  // If you are using TypeScript the state will be
  // const [file, setFile] = useState<FileList | null>(null);
  console.log("Props in = ", props)
  const [file, setFile] = useState(null);
  const accessToken = localStorage.getItem('accessToken');
  const submitFile = async (e) => {
    e.preventDefault()
    try {
      if (!file) {
        throw new Error('Select a file first!');
      }
      console.log("INSIDE UPLAOD API CALL")
      const formData = new FormData();
      formData.append('file', file[0]);
      formData.append('name', props.imageName)
      console.log("file here = ", formData)
      const baseURL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_HOST_URL : 'http://localhost:8080';
      await axios.post(baseURL+`/perk/uploadIcon`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': 'Bearer '+accessToken
        },
      });
      alert("Image has been stored. Please continue.")
      // handle success
    } catch (error) {
      // handle error
    }
  };

  return (
    <form>
      <label >Upload file</label>
      <input type="file" onChange={event => setFile(event.target.files)} />
      <button type="submit" onClick={(e)=>submitFile(e)}>Send</button>
    </form>
  );
};

export const BlogImageUpload = (props) => {
  // If you are using TypeScript the state will be
  // const [file, setFile] = useState<FileList | null>(null);
  console.log("Props in = ", props)
  const [file, setFile] = useState(null);
  // const [imgurl, setImgurl] = useState()
  const accessToken = localStorage.getItem('accessToken');
  const submitFile = async (e) => {
    e.preventDefault()
    try {
      if (!file) {
        throw new Error('Select a file first!');
      }
      console.log("INSIDE UPLAOD API CALL")
      const formData = new FormData();
      formData.append('file', file[0]);
      formData.append('name', props.imageName)
      console.log("file here = ", formData)
      const baseURL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_HOST_URL : 'http://localhost:8080';
      const res = await axios.post(baseURL+`/blog/uploadImage`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': 'Bearer '+accessToken
        },
      });
      console.log("response from img upload = ", res.data)
      props.setImgurl(res.data.Location)
      alert("Image has been stored. Please continue.")
      // handle success
    } catch (error) {
      // handle error
    }
  };

  return (
    <form>
      <label >Upload file</label>
      <input type="file" onChange={event => setFile(event.target.files)} />
      <button type="submit" onClick={(e)=>submitFile(e)}>Send</button>
    </form>
  );
};
// export default {FileUpload, BlogImageUpload};